module.exports = __webpack_public_path__ + "img/26.c56faf66.png";